export default __webpack_public_path__ + "static/media/arrow.46295fcf.svg";